import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { LoadingSkeletonDirective } from 'common-ui';

@Component({
  selector: 'ideal-components-page',
  standalone: true,
  imports: [LoadingSkeletonDirective],
  templateUrl: './components.component.html',
  styleUrl: './components.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentsPageComponent {
  protected readonly isItTrue = signal(true);
}
